import classNames from 'classnames';
import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import { UserType } from '../../graphql/generated/graphqlTypes';
import PostFavoriteButton from './PostFavoriteButton';
import PostTOCButton from './PostTOCButton';
import PostThankButton from './PostThankButton';

type PostActionButtonsProps = {
  postId: string;
  horizontal?: boolean;
};

const PostActionButtons = ({ postId, horizontal }: PostActionButtonsProps) => {
  const currentUser = useAppSelector((state) => state.session.user);
  const classes = classNames('post-actions', {
    'post-actions-horizontal': horizontal,
  });

  return (
    <div className={classes}>
      {horizontal ? (
        <>
          {currentUser.id && currentUser.type !== UserType.Visitor && (
            <PostThankButton postId={postId} hideCount />
          )}
          <PostTOCButton postId={postId} />
        </>
      ) : (
        <>
          <PostTOCButton postId={postId} />
          {currentUser.id && currentUser.type !== UserType.Visitor && (
            <>
              <PostFavoriteButton postId={postId} />
              <PostThankButton postId={postId} />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default PostActionButtons;
